import about_img from "../assets/images/about_new.png";
import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "../i18n";

const About = () => {
  const { t } = useTranslation();

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng); // Change language
  // };
  return (
    <>
      <section id="about" className="py-5">
        <div className="container">
          <div className="row g-4 d-flex align-items-center">
            <div className="col-12 col-md-6">
              <img
                src={about_img}
                data-aos="fade-up"
                className="rounded-5"
                alt="about_img"
              />
            </div>
            <div className="col-12 col-md-6" data-aos="fade-up">
              <h2>{t("AboutUs")}</h2>
              <p className="lead description">{t("AboutUsDescription")}</p>
              {/* <a
                href="https://wa.me/37129825460"
                className="btn btn-lg"
                target="_blank"
                rel="noreferrer"
              >
                {t("BookNow")}
              </a> */}
              <div className="d-flex flex-wrap">
                <a
                  href="https://wa.me/37129825460"
                  className="btn btn-lg me-0 me-md-3"
                  style={{ backgroundColor: "#25D366", color: "white" }}
                >
                  <FaWhatsapp className="me-1" /> {t("WhatsApp")}
                </a>
                <a
                  href="https://t.me/+37129825460"
                  className="btn btn-lg mt-2 mt-md-0"
                  style={{ backgroundColor: "#0088cc", color: "white" }}
                >
                  <FaTelegram className="me-1" /> {t("Telegram")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
